/* esm.sh - applesauce-common@5.2.0/operations/tag/bookmarks */
export * from "/*applesauce-common@5.2.0/esnext/operations/tag/bookmarks.mjs";
